/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown> }} Import_Commit_FailedInputs */

const cs_import_commit_failed = /** @type {(inputs: Import_Commit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import selhal (${i?.failed} selhalo).`)
};

const en_import_commit_failed = /** @type {(inputs: Import_Commit_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import failed (${i?.failed} failed).`)
};

/**
* | output |
* | --- |
* | "Import failed ({failed} failed)." |
*
* @param {Import_Commit_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_commit_failed = /** @type {((inputs: Import_Commit_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Commit_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_commit_failed(inputs)
	return cs_import_commit_failed(inputs)
});